import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const Docusign = Loadable({
  loader: () => import("./components/docusign"),
  loading: Loading,
});
const DocusignInterview = Loadable({
  loader: () => import("./components/docusign_interview"),
  loading: Loading,
});

export const routes = [
  {
    path: "/docusign",
    exact: true,
    name: "docusign",
    component: Docusign,
  },
  {
    path: "/docusign_interview",
    exact: true,
    name: "docusign_interview",
    component: DocusignInterview,
  },
];
